import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import { ErrorOutline, Close as CloseIcon } from '@mui/icons-material';
import PlatformDialog from '../PlatformDialog/PlatformDialog';
import PlatformDialogTitle from '../PlatformDialog/PlatformDialogTitle';

const ConfirmDialog = ({ open, title, message, confirmText, cancelText, onConfirm, onCancel }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const primaryColor = theme.palette.primary.main;

  return (
    <PlatformDialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
    >
      <PlatformDialogTitle
        title={title || 'Confirmar exclusão'}
        icon={<ErrorOutline color="error" />}
        onClose={onCancel}
        color="error.main"
      />
      <DialogContent sx={{ pt: 3.5, pb: 2, px: 3 }}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, gap: 1.5 }}>
        <Button
          onClick={onCancel}
          variant="text"
          sx={{
            minWidth: 80,
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          {cancelText || 'Cancelar'}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          sx={{
            minWidth: 80,
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          {confirmText || 'Excluir'}
        </Button>
      </DialogActions>
    </PlatformDialog>
  );
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog; 